import { CalculationFunction } from 'src/app/enums/stations/calculation-function';
import { PreselectionDatePickerType } from '../component/enums/preselection-date-picker-type';
import { DataTimeStepType } from 'src/swagger-gen/web-secured/models';

export class DateStartEndModel {
    dateStart: string;
    dateEnd: string;
    preSelectionType: PreselectionDatePickerType;
    stepType?: DataTimeStepType;
    stepRange?: number;
    calculation?: CalculationFunction;
    constructor() {
    }
}

